import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
} from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { ButtonFill, ButtonSize } from '@lyceo/shared/util-models';
import { FeedbackModalComponent } from '../feedback-modal/feedback-modal.component';
import { ButtonComponent } from '@lyceo/shared/ui';

@Component({
  selector: 'lyceo-feedback-button',
  imports: [ButtonComponent],
  templateUrl: './feedback-button.component.html',
  styleUrls: ['./feedback-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackButtonComponent {
  private readonly modalController: ModalController = inject(ModalController);

  public buttonFill: ButtonFill = ButtonFill.OUTLINE;
  public buttonSize: ButtonSize = ButtonSize.SMALL;
  public readonly modalTitle: InputSignal<string> = input('Feedback?');
  public readonly modalBodyText: InputSignal<string> = input(
    'Zie je een foutje, bug of mis je een onderwerp?',
  );
  public readonly modalButtonText: InputSignal<string> = input(
    'Mail naar supportoefenen@lyceo.nl',
  );
  public readonly buttonText: InputSignal<string> = input('Feedback');

  public async openFeedbackModal(): Promise<void> {
    const modal: HTMLIonModalElement = await this.modalController.create({
      component: FeedbackModalComponent,
      componentProps: {
        modalTitle: this.modalTitle(),
        modalBodyText: this.modalBodyText(),
        modalButtonText: this.modalButtonText(),
      },
      backdropDismiss: true,
      cssClass: 'auto-height-modal feedback-modal',
    });
    await modal.present();
  }
}
